<template>
    <section
        v-editable="blok"
        class="service-cards"
        :class="`service-cards--cols-${blok.columns || 'auto'}`"
    >
        <KSectionHeader
            v-if="blok.eyebrow || blok.title || blok.text"
            class="service-cards__header"
            :eyebrow="blok.eyebrow"
            :title="blok.title"
            :text="blok.text"
            :align="blok.align || 'center'"
        >
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="service-cards"
                />
            </template>
        </KSectionHeader>

        <div
            v-if="blok.cards?.length"
            class="service-cards__grid"
        >
            <service-card
                v-for="card in blok.cards"
                :key="card._uid"
                :blok="card"
                :tone="card.tone || blok.tone || 'accent'"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'

const { blok } = defineProps(['blok'])
</script>

<style lang="scss">
@use 'service-cards';
</style>
